<template>
  <div class="aside-order-help-component">
    <div class="flex align-start">
      <font-awesome-icon icon="headset" />
      <span v-if="currentStep === 0" class="help-text">
        Компания "{{ companyName }}". <br>
        Меня зовут {{ userName }}.
        Здравствуйте!

        <!--        Здравствуйте, доставка {{ companyName }}! Меня зовут {{ userName }}, как могу к вам
        обращаться?-->
      </span>

      <span v-if="currentStep === 1" class="help-text">
        Вам потребуется доставка или хотите забрать заказ самостоятельно?
        <!--        <template v-if="getClientName">
          {{ getClientName }},
        </template>
        на какой адрес совершить доставку?-->
      </span>

      <span v-if="currentStep === 2" class="help-text">
        <template v-if="getClientName">
          {{ getClientName }},
        </template>
        что будете сегодня заказывать?
      </span>

      <span v-if="currentStep === 3" class="help-text">
        <template v-if="getClientName">
          {{ getClientName }},
        </template>
        как будете оплачивать заказ?
      </span>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'OrderHelp',
    props: {
      text: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        userName: '',
      }
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        currentNewOrderStep: state => state.newOrder.currentStep,
        currentEditOrderStep: state => state.fastOrder.currentStep,
        companyName: state => state.app.companyName,
      }),
      ...mapGetters({
        isNewOrderPage: 'app/isNewOrderPage',
      }),
      currentStep () {
        return this.isNewOrderPage ? this.currentNewOrderStep : this.currentEditOrderStep
      },
      getClientName () {
        return this.basket.client ? this.basket.client.name : ''
      },
    },
    mounted () {
      const userData = JSON.parse(localStorage.getItem('user'))
      this.userName = userData.data.firstName
    },
  }
</script>

<style lang="less" scoped>
.aside-order-help-component {
  position: relative;
  margin-top: 25px;
  margin-bottom: 30px;
  background-color: #fff3d6;
  border-radius: 10px;
  padding: 1.5em 0.86em 1em;
  z-index: 0;

  &:after {
    content: '';
    position: absolute;
    left: 5px;
    top: -10px;
    border: 12px solid;
    border-color: transparent #fff3d6 transparent transparent;
  }

  svg {
    width: 1.79em;
    height: 1.79em;
    margin-right: 1.5em;
    /*font-size: 16px;
    line-height: 19px;*/
    .fill-svg(#E1CD9D);
  }

  .help-text:first-letter {
    text-transform: capitalize;
  }

}
</style>
